"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16LocationPinEnabledLine = function Svg16LocationPinEnabledLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M14 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18l-1.495 1.329-.003-.003-.004-.005-.012-.014-.042-.048-.145-.17a27.241 27.241 0 0 1-1.98-2.677c-1.013-1.57-2.319-3.97-2.319-6.293C6 6.796 8.631 4 12 4s6 2.796 6 6.12c0 2.321-1.306 4.723-2.32 6.293a27.223 27.223 0 0 1-2.124 2.846l-.042.048-.012.014-.005.005-.002.003L12 18zm0 0s.562-.632 1.264-1.6C14.436 14.784 16 12.233 16 10.12 16 7.843 14.21 6 12 6s-4 1.844-4 4.12c0 2.113 1.564 4.664 2.736 6.28C11.438 17.368 12 18 12 18z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M12 18l-1.495 1.329a2 2 0 0 0 2.99 0L12 18z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16LocationPinEnabledLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16LocationPinEnabledLine;
exports.default = _default;